// extracted by mini-css-extract-plugin
module.exports = {"fan":"auth_fan__YZHIh"};